import React, { Component } from 'react'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import TextField from 'material-ui/TextField'

class YVTextField extends Component {
    constructor(props) {
        super(props)
        this.onChange = this.onChange.bind(this)
        this.onFocus = this.onFocus.bind(this)
        this.onBlur = this.onBlur.bind(this)
    }
    init(props) {
        const { onFocus, onBlur, item } = props
        if (item) {
            if (item.autoSelect) {
                this.refs.myField.focus()
                this.refs.myField.getInputNode().setSelectionRange(0, 9999)
            }
            if (item.focus) {
                onFocus && onFocus(item, null, this.refs.myField)
            }
        }
    }
    componentWillReceiveProps(props) {
        this.init(props)
    }
    componentDidMount() {
        this.init(this.props)
    }
    onChange(e) {
        const { onChange, item } = this.props
        onChange && onChange(item, e)
    }
    onFocus(e) {
        const { onFocus, item } = this.props
        onFocus && onFocus(item, e, this.refs.myField)
    }
    onBlur(e) {
        const { onBlur, item } = this.props
        onBlur && onBlur(item, e)
    }
    handleOptionalFields(item) {
        const fields = {}

        if (!item) {
            return {}
        }
        if (item.error) {
            fields.errorText = item.error
        }
        if (item.placeholder) {
            fields.floatingLabelText = item.placeholder
        }
        if (item.disabled) {
            fields.disabled = item.disabled
        }
        if (item.readOnly) {
            fields.readOnly = item.readOnly
        }
        if (item.value) {
            fields.defaultValue = item.value
        }
        if (item.rows) {
            fields.rows = item.rows
        }

        return Object.assign({}, fields, item.style)
    }
    render() {
        const { item, ...props } = this.props
        const values = this.handleOptionalFields(item)

        return (
            <MuiThemeProvider>
                <TextField
                    {...props}
                    {...values}
                    ref="myField"
                    onChange={this.onChange}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                />
            </MuiThemeProvider>
        )
    }
}

export default YVTextField
